module.exports = __webpack_public_path__ + "img/case-SSL-unload.2da80b5f.png";